import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import FixedChoiceDraggable from './FixedChoiceDraggable';

const SortableFixedChoiceItem = ({ id, item }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes}>
            <FixedChoiceDraggable item={item} dragHandleProps={listeners} />
        </div>
    );
};

export default SortableFixedChoiceItem;
